import { type BaseNotificationItemProps, NotificationItem } from '../components/NotificationItem'

export type NewEngagementProps = BaseNotificationItemProps & {
  name: string
  targetEntityId: string
  type: 'new-engagement'
}

export function NewEngagement({ name, targetEntityId, ...props }: NewEngagementProps) {
  return (
    <NotificationItem
      {...props}
      title={`${name} created a new engagement`}
      descriptionAddon={<p className='line-clamp-1 text-left text-sm text-gray-500'>{targetEntityId}</p>}
    />
  )
}
